import React, { useEffect, useState } from "react";
import EditModal from "@core/modals/EditModal";
import EditButton from "@core/buttons/atoms/EditButton";
import Input from "@core/inputs/Input";
import { showError, showSuccess } from "@utils/helpers";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import GeoSubAreaService from "@services/GeoSubAreaService";
import StatisticalDivisionSelect from "@components/StatisticalDivision/partials/StatisticalDivisionSelect";

const EditGeoSubArea = ({ geoSubArea, onEdited }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const [englishName, setEnglishName] = useState("");
  const [description, setDescription] = useState("");
  const [statisticalDivision, setStatisticalDivision] = useState("");
  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    setShowModal(false);
    setName("");
    setEnglishName("");
    setDescription("");
    setStatisticalDivision(null);
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    GeoSubAreaService.update(
      geoSubArea.id,
      name,
      englishName,
      description,
      statisticalDivision
    )
      .then(() => {
        showSuccess(t("geoSubAreaEditedSuccessfully"));
        onEdited();
        closeModal();
      })
      .catch((err) => {
        showError(err.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (showModal)
      GeoSubAreaService.find(geoSubArea.id).then((response) => {
        setName(response.data.data.name);
        setEnglishName(response.data.data.name_eng);
        setDescription(response.data.data.description);
        setStatisticalDivision(response.data.data.fao_statistical_division_id);
      });
  }, [geoSubArea.id, showModal]);

  return (
    <PermissionHandler permission={"update_geo_sub_area"}>
      <EditButton onClick={() => setShowModal(true)} />
      <EditModal
        show={showModal}
        title={t("editGeoSubArea")}
        onClose={closeModal}
        onSubmit={onSubmit}
        loading={loading}
        label={t("edit")}
      >
        <div className="mt-4 sm:mt-8 mb-2 grid grid-cols-2 gap-5">
          <Input
            label={t("name")}
            placeholder={t("name")}
            value={name}
            onChange={setName}
            height="h-10"
          />
          <Input
            height="h-10"
            label={t("nameEng")}
            placeholder={t("nameEng")}
            value={englishName}
            onChange={setEnglishName}
          />
          <Input
            height="h-10"
            label={t("description")}
            placeholder={t("description")}
            value={description}
            onChange={setDescription}
          />
          <div>
            <div className="text-xs font-semibold mb-2 flex">
              {t("statisticalDivision")}
              <div className="text-red-600 ml-1">*</div>
            </div>
            <StatisticalDivisionSelect
              openModal={showModal}
              onSelect={setStatisticalDivision}
              selected={statisticalDivision}
            />
          </div>
        </div>
      </EditModal>
    </PermissionHandler>
  );
};

export default EditGeoSubArea;
